export default __webpack_public_path__ + "static/media/Country.5449610a.png";